module.exports = __webpack_public_path__ + "static/media/PEC-vConnect_desktop-setting-control.3a8d7649.jpg";